import firebase from 'firebase/app';
import 'firebase/messaging';

import {
  deleteNotificationUnSubcribe,
  putNotificationSubcribe,
  putNotificationSubcribeCulture
} from '../client/adminClient';
import { configCulture, configPerformance } from './FirebaseConfig';

export const unSubcribeFirebase = async () => {
  try {
    const registrations = await navigator.serviceWorker.getRegistrations();
    for (const registration of registrations) {
      registration.unregister();
    }
    const messaging = firebase.messaging();
    await messaging.deleteToken();
    await deleteNotificationUnSubcribe();
    // eslint-disable-next-line no-empty
  } catch (e) {}
};

export const initializeFirebase = async (accessToken) => {
  try {
    const isFirebaseSuported = firebase.messaging.isSupported();
    if (!isFirebaseSuported || !('serviceWorker' in navigator)) return;

    const permission = await Notification.requestPermission();
    if (permission !== 'granted') return;

    const registrations = await navigator.serviceWorker.getRegistrations();
    if (!registrations || registrations.length === 0) {
      const registration = await navigator.serviceWorker.register(
        '/firebase-messaging-sw.js'
      );
      if (registration.active) {
        registration.active.postMessage({ configPerformance });
      }
    }

    await navigator.serviceWorker.ready;

    let app;
    if (firebase.apps.length === 0) {
      app = firebase.initializeApp(configPerformance);
    } else {
      app = firebase.app();
    }

    const firebaseToken = await app.messaging().getToken();
    localStorage.setItem(
      'firebaseNotifPerfToken',
      JSON.stringify(firebaseToken)
    );
    await putNotificationSubcribe({
      device_type: 'android',
      token: firebaseToken,
      accessToken: accessToken
    });
    // eslint-disable-next-line no-empty
  } catch (e) {}
};

export const initializeFirebaseCulture = async (accessToken) => {
  try {
    const isFirebaseSuported = firebase.messaging.isSupported();
    if (!isFirebaseSuported || !('serviceWorker' in navigator)) return;

    const permission = await Notification.requestPermission();
    if (permission !== 'granted') return;

    const registrations = await navigator.serviceWorker.getRegistrations();
    if (!registrations || registrations.length === 0) {
      const registration = await navigator.serviceWorker.register(
        '/firebase-messaging-culture-sw.js'
      );
      if (registration.active) {
        registration.active.postMessage({ configCulture });
      }
    }

    await navigator.serviceWorker.ready;

    let app;
    if (firebase.apps.length === 0) {
      app = firebase.initializeApp(configCulture, 'cultureInitialize');
    } else {
      app = firebase.app('cultureInitialize');
    }

    const cultureToken = await app.messaging().getToken();
    localStorage.setItem(
      'firebaseNotifCultureToken',
      JSON.stringify(cultureToken)
    );
    await putNotificationSubcribeCulture({
      device: {
        device_type: 'android',
        token: cultureToken,
        accessToken: accessToken
      }
    });
    // eslint-disable-next-line no-empty
  } catch (e) {}
};
